import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Profile.css';
import BlankStarSrc from '../../../assets/images/Profile/progress_bar_blank_star.svg'
import FilledStarSrc from '../../../assets/images/Profile/progress_bar_filled_star.svg'
import bookImgSrc from '../../../assets/images/Profile/book.png'
import { Line } from 'rc-progress';
import {
    isMobile,
    isDesktop,
} from '../../../helper/mediaQueries';
import MediaQuery from 'react-responsive';
import AchievementDialog from '../../../components/Notification/AchievementDialog';
import IconButton from 'material-ui/IconButton';
import HelpIcon from 'material-ui-icons/Help';
import {connect} from 'react-redux';

class Profile extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        school: PropTypes.string,
        grade: PropTypes.number.isRequired,
        booksRead: PropTypes.number.isRequired,
        levelName: PropTypes.string,
        levelImage: PropTypes.string,
        accessibilityName: PropTypes.string,

    }

    constructor(props) {
    	super(props);
    	const {gradeName} = props;
    	const booksMustRead1 = gradeName.indexOf("K") > -1 ? 30 : 20;
        const booksMustRead = gradeName.indexOf("9") > -1 ? 20 : booksMustRead1;
    	//const booksMustRead = 20 ;
    	this.state={
    	        isDialogOpen: false,
    	        booksMustRead
    	    }
    }



    handleDialogClose = () => {
        this.setState({ isDialogOpen: false });
    }

    helpIconClickHandler = () => {
        this.setState({ isDialogOpen: true });
    }

    renderProgressMarker = () => {
        const totalMarkerNumber = this.state.booksMustRead / 5;
        let markers = [];
        for( var i = 0; i < totalMarkerNumber; i++ ) {
            markers.push(
                <img
                    className="profile__progressBar--singleMark"
                    key={i}
                    //For every 5 books in the Reading Log, one marker will filled with color
                    src={this.props.booksRead/5 >= i+1 ? FilledStarSrc : BlankStarSrc}
                    alt=""/>
            )
        }
        return markers
    }

    renderReadNumbers = () => {
        return `${this.props.booksRead}/${this.state.booksMustRead}`
    }

    renderProgressBar = () => {
        const {gradeName, booksRead} = this.props;
        const {booksMustRead} = this.state;

    	return  <div className="profile__progressBar--number">
                    <p><span>{booksRead}/{booksMustRead} </span>
                        Books read  :
                    </p>
                    <div className="profile__progressBar--marks--wrapper">
                        <div className="profile__progressBar--marks">
                            <div className="profile__progressBar--marks--holder"></div>
                            {this.renderProgressMarker()}
                        </div>
                        <Line
                            alt="progress bar"
                            strokeLinecap="round"
                            percent={booksRead / booksMustRead * 100}
                            trailWidth="6"
                            strokeWidth="6"
                            strokeColor="#FE154B" />
                    </div>
                </div>
    }

    renderProgressComplete = (number) => {
        return  <div className="profile__progress--complete">
                    <img src={bookImgSrc} alt="" width={40} height={50}/>
                    <div>
                        <p>Continue reading for leisure & pleasure</p>
                        <p><span>{number}</span> books read</p>
                    </div>
                </div>
    }

    renderProgress = () => {
        const extraReadBooks = this.props.booksRead - this.state.booksMustRead;
        return extraReadBooks >= 0 ? this.renderProgressComplete(extraReadBooks) : this.renderProgressBar()
    }

    render () {
        const {
            name,
            grade,
            school,
            levelName,
            levelImage,
            accessibilityName,
        } = this.props;
        return (
            <div>
                <AchievementDialog
                    isOpen={this.state.isDialogOpen}
                    dialogCloseHandler={this.handleDialogClose}
                    isRenderHelpInfo
                />
                <div className="profile__wrapper">
                    <div className="profile__info">
                        <div>
                            <h2 className="profile__info--name">{name}</h2>
                            <p className="profile__info--year">{'Year ' } {Number.isInteger(grade) ? grade : 'K'}</p>
                            <p>{school}
                                <IconButton
                                    aria-label="help"
                                    className="profile__info--school--help"
                                    onClick={ () => this.helpIconClickHandler()}>
                                    <span className="sr-only">help</span>
                                    <HelpIcon/>
                                </IconButton>
                            </p>
                        </div>
                    </div>

                    <MediaQuery query={isDesktop}>
                        <div className="profile__progressBar progressBar__desktop ">
                            {this.renderProgress()}
                        </div>
                    </MediaQuery>

                    <div className="profile__level">
                        <div className="profile__level--info">
                            <h3 className="profile__level--name">
                                {levelName}
                            </h3>
                            <p className="profile__level--current">Current Level</p>
                        </div>
                        <div className="profile__level--image">
                            <img src={levelImage} width={70} height={70} alt={accessibilityName}/>
                        </div>
                    </div>
                </div>
                <MediaQuery query={isMobile}>
                    <div className="profile__progressBar">
                        {this.renderProgress()}
                    </div>
                </MediaQuery>
            </div>
        );
    }
}

const mapStateToProps = state => {

	//const gradeName = state.student.studentDetails.readingLevels;
	const gradeName = state.student.readingRecord.readingLevels;
    return {
    	gradeName
    }
};

export default connect(mapStateToProps)(Profile)
